import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { LanguageProvider } from './contexts/LanguageContext'
import ProtectedRoute from './components/ProtectedRoute'

// Layouts
import UserLayout from './layouts/UserLayout'

// Pages
import Login from './pages/Login'
import Register from './pages/Register'
import Home from './pages/Home'
import Matches from './pages/Matches'
import CreateMatch from './pages/CreateMatch'
import MatchDetails from './pages/MatchDetails'
import Profile from './pages/Profile'
import Notifications from './pages/Notifications'
import Search from './pages/Search'
import SportsCenters from './pages/SportsCenters'

function App() {
  return (
    <ThemeProvider>
      <LanguageProvider>
        <AuthProvider>
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              <Route element={<ProtectedRoute />}>
                <Route element={<UserLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/matches" element={<Matches />} />
                  <Route path="/create-match" element={<CreateMatch />} />
                  <Route path="/match/:id" element={<MatchDetails />} />
                  <Route path="/profile/:userId?" element={<Profile />} />
                  <Route path="/notifications" element={<Notifications />} />
                  <Route path="/search" element={<Search />} />
                  <Route path="/centers" element={<SportsCenters />} />
                </Route>
              </Route>
            </Routes>
          </Router>
        </AuthProvider>
      </LanguageProvider>
    </ThemeProvider>
  )
}

export default App